import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import User from "../../types/User";

const initialState: {
  users?: Array<User>;
  total?: number;
  pageSize: number;
  page: number;
} = {
  pageSize: 15,
  page: 1,
};

export const usersReducer = createSlice({
  name: "users",
  initialState,
  reducers: {
    loadUsers(state, action) {
      state.pageSize = action.payload.pageSize;
      state.page = action.payload.page;
    },
    setLoadedUsers(state, action) {
      state.users = action.payload.users;
      state.total = action.payload.total;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    activateUser(_state, _action: PayloadAction<number>) {},
    activateUserSuccess(state, action: PayloadAction<User>) {
      const index = state.users?.findIndex(x => action.payload.id === x.id);
      if (index !== undefined && index !== -1 && state.users) {
        state.users[index] = action.payload;
      }
    },
  },
});

export const { loadUsers, setLoadedUsers, activateUser, activateUserSuccess } =
  usersReducer.actions;
